const DEFAULT_PAY_BASE_URL = "https://pay.rockethealth.app";

// Public checkout origin (overridable for non-prod testing). Mirrors the helper
// used by build-therapy-reschedule-payment-link.
export function getPayBaseUrl(): string {
  const raw = (
    import.meta.env.VITE_ROCKETHEALTH_PAY_BASE_URL as string | undefined
  )?.trim();
  const base = raw && raw.length > 0 ? raw : DEFAULT_PAY_BASE_URL;
  return base.endsWith("/") ? base.slice(0, -1) : base;
}

// Full public payment URL for a slug, e.g. "https://pay.rockethealth.app/therapy-4".
export function buildPaymentUrl(slug: string): string {
  return `${getPayBaseUrl()}/${slug.trim()}`;
}
